<template>
  <b-row>
    <b-col sm="12">

      <b-card body-class="py-2">
        <section class="list-view-heading">
          <div class="crud-php-code-heading d-none d-md-flex" v-if="php">
            <span class="crud-php-code-heading__icon"><AppIcon name="data_object" /></span>
            <p class="crud-php-code-heading__text" v-if="php.observations">{{php.observations}}</p>
          </div>
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-dropdown right
                          no-caret
                          variant="link"
                          boundary="window"
                          toggle-class="list-view-icon-btn list-view-icon-btn--primary"
                          v-b-tooltip.hover.bottom
                          title="Opciones">
                <template #button-content>
                  <AppIcon name="settings" label="Opciones" />
                </template>
                <b-dropdown-item @click="openBackups()"><AppIcon name="clock-history" /> Respaldos de Código</b-dropdown-item>
                <b-dropdown-item @click="openSnippets()"><AppIcon name="data_object" /> Bloques de Código</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>
      </b-card>

      <b-card no-body>
        <prism-editor v-model="crud.form.code" language="php" class="php-editor-code" :readonly="php && php.blocked == 1"></prism-editor>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="goBack()">
            <AppIcon name="back" class="mr-1" />Volver
          </b-button>

          <b-button variant="dark" @click="save()" size="sm" v-if="php && !php.blocked">
            <AppIcon name="save" class="mr-1" />Guardar
          </b-button>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.snippets.active"
              size="xl"
              :key="modal.snippets._id"
              :id="modal.snippets._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="data_object" /></span>
          <h5 class="app-modal-header__title">{{this.modal.snippets.title}}</h5>
        </div>

        <Snippets v-if="this.php" :origen="php.type"></Snippets>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.snippets.active=false"><AppIcon name="x" class="mr-1" />Cerrar</b-button>
        </div>
      </b-modal>

      <!-- CRUD BACKUPS -->
      <b-modal v-model="modal.backups.active"
              size="xl"
              :key="modal.backups._id"
              :id="modal.backups._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="clock-history" /></span>
          <h5 class="app-modal-header__title">{{this.modal.backups.title}}</h5>
        </div>

        <Backups v-if="this.php" :php-id="php.id" :code="crud.form.code" :items="php.backups || []"></Backups>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.backups.active=false"><AppIcon name="x" class="mr-1" />Cerrar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'
  import { EventBus } from '@/handler/event-bus'

  import Snippets from './inc/snippets'
  import Backups from './inc/backups'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  import PrismEditor from 'vue-prism-editor'
  import Prism from "prismjs";  
  import "prismjs/themes/prism.css";  
  import "prismjs/components/prism-markup-templating";  
  import 'prismjs/components/prism-php';

  export default {  
    components: {
      PrismEditor,
      Snippets,
      Backups,
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.PHP,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudPHPCode',
          elements: {}
        },
        crud: {
          form: {
            id: '',
            code: '',
            blocked: false,            
          },          
        },         
        modal: {
          snippets: {
            active: false,
            title: ''
          },
          backups: {
            active: false,
            title: ''
          },
        },
        php: null,    
        params: null,
        initialCode: '',
        dirty: false,                   
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {              
      if(this.$route.params.id) {
        this.params = this.$route.params
      } else {
        this.$router.push({ name: 'PHPStaffDashboard' })
        return
      }

      this.load()

      this._start = true
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      if(this.$route.params.id && !this.php){
        this.params = this.$route.params
        this.load()        
        return false
      }

      if(!this.$route.params.id && this.php){
        this.params.id = this.php.id
        return false
      }

      if(this.$route.params.id && this.php && (this.$route.params.id != this.php.id)) {
        if(this.dirty) {
          if (confirm("Se abrirá un nuevo código, ¿necesita guardar el código actual?")) {
            if(confirm("¿Confirma guardar guardar el código actual?")) {
              this.save()
            }
          }
        }

        this.params = this.$route.params
        this.load()
      } else {
        this.load()
      }
    },
    computed: {
      typeView() {
        return this.php ? this.php.type : ''
      }
    },
    watch: {
      'crud.form.code'(value) {
        if(this.php) {
          this.dirty = value !== this.initialCode
        }
      }
    },
    methods: {  
      load() {
        if(!this.params || !this.params.id) {
          this.$router.push({ name: 'PHPStaffDashboard' })
          return false
        }

        this.crud.form.id = this.params.id  
        var result = serviceAPI.mostrarPHP(this.crud.form.id)

        result.then((response) => {
          var data = response.data
          this.crud.form.id = data.id
          this.crud.form.code = data.code

          this.php = data
          this.initialCode = data.code || ''
          this.dirty = false
          EventBus.$emit('Update:TabMetadata', {
            title: this.php.name,
            subtitle: this.php.observations,
            icon: 'data_object',
          })
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      }, 
      save() {
        let loader = this.$loading.show();
        
        var result = serviceAPI.guardarCodePHP(this.crud.form);
                
        result.then((response) => {                    
          loader.hide()
          this.load()
          this.$awn.success("Código guardado");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },   

      goBack() {
        if(this.typeView == 'interface') {
          this.$router.push({ name: 'PHPStaffCrudPHPInterfaces' })          
        }
        if(this.typeView == 'cron') {
          this.$router.push({ name: 'PHPStaffCrudPHPCron' })          
        }
        if(this.typeView == 'callback') {
          this.$router.push({ name: 'PHPStaffCrudPHPCallback' })          
        }                

        if(this.typeView == '') {
        this.$router.go(-1)
        }
      },
      
      openSnippets() {
        this.modal.snippets._id = Math.random().toString(36).slice(2, 8)
        this.modal.snippets.title = "Bloques de Código"
        this.modal.snippets.active = true
      },

      openBackups() {
        this.modal.backups._id = Math.random().toString(36).slice(2, 8)
        this.modal.backups.title = "Respaldos de Código"
        this.modal.backups.active = true
      }
    }
  }
</script>
<style scoped>
  .crud-php-code-heading {
    align-items: center;
    display: flex;
    gap: 8px;
    min-height: 36px;
  }
  .crud-php-code-heading__icon {
    align-items: center;
    background: var(--app-color-primary-soft);
    border-radius: 8px;
    color: var(--app-color-primary);
    display: inline-flex;
    flex: 0 0 28px;
    font-size: 0.85rem;
    height: 28px;
    justify-content: center;
    width: 28px;
  }
  .crud-php-code-heading__text {
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-medium);
    margin: 0;
  }
</style>
<style>
  .php-editor-code {
    height: calc(100vh - 300px);
    min-height: 320px;
    overflow: auto;
  }
  .php-editor-code pre {
    min-height: 100%;
  }
</style>
